import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import { utils, chttp, apis } from '@/libs/interfaces';
import openDayVipToast from '@/components/app/adsense/dayVip';
import { reportPay } from '@/libs/utils/log/log';
import { raisePaymentWithAb } from '@/libs/utils/raisePaymentWithAb'
import {
  firstHomeToast,
  searchFirstToast,
  // eslint-disable-next-line import/named
  djhotToast,
  SearchResultHQsongRole4,
  secondHomeToastRole2,
  newUserPop2,
  vipFirstRole4,
  vipFirstTopRole2,
  vipFirstSearchRole5,
  searchFirstToastNew,
} from '@/libs/app/config/payment'

// 常量定义
const ONEDAY_TIMESTAMP = 24 * 60 * 60 * 1000;

// 用户类型配置
const NEW_USER = {
  homeToast: {
    pay_enter: 'new_coopenAdvertising',
    name: '新开屏弹窗开通VIP',
  },
  orderSong: {
    pay_enter: 'new_orderSongtovip',
    name: '新点歌后弹窗开通VIP',
  },
  maiba: {
    pay_enter: '5',
    name: '开场特效',
  },
};

// 弹窗数据配置
const TOAST_DATA = {
  interact: {
    img: 'https://qncweb-back1.ktvsky.com/20210518/vadd/1a29cb2ba2156d72dd1aeb26c179622c.png',
    pay_enter: 'oldvip_interact',
    page: '娱乐页弹窗',
    name: '娱乐',
  },
  homeToast: {
    img: 'https://qncweb-back1.ktvsky.com/20210518/vadd/de616cbacb5afb5e9cb9807eed53c9b4.png',
    pay_enter: 'oldvip_kaiping',
    page: '开屏弹窗',
    name: '特权',
  },
  orderSong: {
    img: 'https://qncweb-back1.ktvsky.com/20210518/vadd/9b9a8db999a0031956da9f79711e7828.png',
    pay_enter: 'oldvip_diange',
    page: '点歌后弹窗',
    name: '点歌',
  },
  songTop: {
    img: 'https://qncweb-back1.ktvsky.com/20210518/vadd/49e8659c9609a0a725606e3a2228a2f1.png',
    pay_enter: 'oldvip_ordered',
    page: '已点页弹窗',
    name: '置顶',
  },
};

// 个人中心事件配置
const mineEvents = {
  openvip: {
    name: '续费vip',
  },
  card: {
    name: '优惠续费',
    pay_enter: 'mineCardVip',
  },
  mineAdVip: {
    name: '续费横条',
    pay_enter: 'mineAdVip',
  },
};
export default {
  components: {
    openDayVipToast,
  },
  computed: {
    ...mapState({
      vip_endtime: (state) => state.vip_endtime,
      is_vip: (state) => state.is_vip,
      isTestOldVip: (state) => state.isTestOldVip, // 老用户复购测试变量
      openid: (state) => state.openid,
      unionid: (state) => state.unionid,
      is_leike_device: (state) => state.is_leike_device,
      photoPath: (state) => state.photoPath, // 照片权限相关数据
    }),
    endDays() {
      const days = Math.ceil((new Date().getTime() - new Date(this.expire_time).getTime()) / ONEDAY_TIMESTAMP);
      return `亲，您的会员已过期${days}天`;
    },
    isOldVip() {
      return !this.is_vip && this.vip_endtime && this.isTestOldVip;
    },
    isNewUser() {
      return !this.is_vip && !this.vip_endtime;
    },
  },
  data() {
    return {
      photoData: null, // 存储照片权限相关数据
    };
  },
  methods: {
    oldVipToast(payload) {
      if (NEW_USER[payload] && this.isNewUser) {
        this.$store.commit('SAVE_HOME_TOAST', false);
        this.showNewUser();
        return 'isOldVip';
      }
      if (!this.isTestOldVip) return;
      const currentData = TOAST_DATA[payload];
      if (this.isOldVip) {
        this.$RaiseMessage.alert(currentData.img, '', {
          callback: () => {
            this.commonLog(currentData, 'click');
            utils.util.buyVipPlus({
              memberId: 2,
              pay_fee: 990,
              $this: this,
              pay_enter: currentData.pay_enter,
            });
          },
          closeImg: require('@/views/vip/static/plus/vip_close.png'),
        });
        this.commonLog(currentData);
        this.$store.commit('SAVE_HOME_TOAST', false);
        return 'isOldVip';
      }
    },
    openDayVip(statName = 'kaiping_sdcs') {
      this.$sendLog({
        event_type: 'show',
        event_name: '开屏弹窗新用户第二个1日体验',
        event_data: {
          action: '展示',
        },
      });
      // 分时段促销：开屏弹窗2 —— 结束
      this.$RaiseNewPayment({
        ...newUserPop2,
        page_tp: statName,
        event: this,
      });
    },
    openOneDayVip(statName) {
      this.$sendLog({
        event_type: 'show',
        event_name: '一元会员',
        event_data: {
          action: '点歌后弹窗',
        },
      });
      this.$RaiseMessage.alert('https://qncweb-back1.ktvsky.com/20210707/vadd/bc31ca5108346a8e95940d9ec1925c24.png', '', {
        callback: () => {
          this.$sendLog({
            event_type: 'click',
            event_name: '一元会员',
            event_data: {
              action: '点击领取按钮',
            },
          });
          utils.util.buyVipPlus({
            memberId: 107,
            pay_fee: 100,
            $this: this,
            pay_enter: statName,
          });
        },
      });
    },
    openSongGodVip(item) {
      const statNames = this.$route.query.fromType ? '歌神专享特效-弹窗' : '歌神专享搜索页弹窗';
      this.$sendLog({ event_type: 'show', event_name: '歌神点歌弹窗', event_data: { page_name: statNames } });
      this.$RaiseNewPayment({
        contentBg: 'https://qncweb-back1.ktvsky.com/20210816/vadd/962608b67f13d02fa1284b2cdd4a5eb8.png',
        swiperData: [
          'https://qncweb-back1.ktvsky.com/20210816/vadd/962557f34395fd312b4c796ee0a78c19.png',
          'https://qncweb-back1.ktvsky.com/20210816/vadd/a001bab9ba51319f71bd6994d626ee1f.png',
          'https://qncweb-back1.ktvsky.com/20210816/vadd/5a76f89486eae22e734534f64787bfc7.png',
          // 'https://qncweb-back1.ktvsky.com/20210816/vadd/ff8be2884429b91fb68701ebe8edd696.png',
        ],
        page_tp: this.$route.query.fromType,
        statName: statNames,
        event: this,
        songItem: item,
        propStyleVar: {
          fontColor: {
            normal: ['#666666', '#FF0000', '#999999'],
            selected: ['#fff', '#FFFF00', '#fff'],
          },
          packageBg: '#FFFFFF',
          packageBgSelected: 'linear-gradient(0deg,#ac2dbe 0%, #de4085 100%)',
          tipBg: '#C667FD',
          plusColor: '#FF0000',
          tagBg: '#FF0000',
          swiperBulletBg: '#8454C5',
          swiperBulletActiveBg: '#ffffff',
          buttonHeight: '23.2vw',
        },
      });
    },
    openDjhotAlert(event) {
      const $this = event;
      const djhotControl = this.$store2.get('djhotControl');
      const hour = 1000 * 60 * 60 * 3;
      if (djhotControl) {
        if (Date.now() - this.$store2.get('djhotStartTime') < hour) {
          const djShow = this.$store2.get('djhotShow');
          if (!djShow) {
            this.opendjhot($this);
            this.$store2.set('djhotShow', true);
          }
          return;
        }
        this.$store2.remove('djhotControl');
        this.$store2.remove('djhotStartTime');
        this.$store2.remove('djhotShow');
      }
      if (!this.$store2.get('djhotStartTime')) {
        this.$store2.set('djhotControl', true);
        this.$store2.set('djhotStartTime', Date.now());
      }
    },
    opendjhot(event) {
      reportPay({
        page_tp: 'djhot_stay',
        active_tp: 3, // 用户行为：0：点击 ;1：停留
        source: 0,
      });
      this.$RaiseMessage.alert('https://qncweb-back1.ktvsky.com/20210819/vadd/7a4bc0eb16e6a98eec88352cd3d692c1.png', '', {
        callback: () => {
          reportPay({
            page_tp: 'djhot_stay',
            active_tp: 0, // 用户行为：0：点击 ;1：停留
            source: 0,
          });
          utils.util.buyVipPlus({
            memberId: 102,
            pay_fee: 590,
            $this: event,
            pay_enter: 'djhot_stay',
          });
        },
        closeBtn: 'marginTop:7vw',
      });
    },
    openDayVipThree() {
      reportPay({
        page_tp: 'cents_pay',
        active_tp: 3, // 用户行为：0：点击 ;1：停留
        source: 0,
      });
      this.$sendLog({ event_type: 'show', event_name: '一毛会员', event_data: { page_name: '点歌后弹窗' } });
      this.$RaiseMessage.alert('https://qncweb-back1.ktvsky.com/20211108/vadd/c26bac884d20f6de15bc8a6d4c276c60.png', '', {
        closeBtn: 'bottom: -10vw;',
        callback: () => {
          reportPay({
            page_tp: 'cents_pay',
            active_tp: 0, // 用户行为：0：点击 ;1：停留
            source: 0,
          });
          this.$sendLog({
            event_type: 'click',
            event_name: '一毛会员',
            event_data: {
              action: '点击购买按钮',
            },
          });
          utils.util.buyVipPlus({
            memberId: 109,
            pay_fee: 190,
            $this: this,
            pay_enter: 'cents_pay',
          });
        },
      });
    },
    openSongOrdering(fromType) {
      this.$RaiseNewPayment({
        contentBg: 'https://qncweb-back1.ktvsky.com/20210903/vadd/87813e898f81c6f93b1a64f2465ae8a9.png',
        swiperData: [
          'https://qncweb-back1.ktvsky.com/20210708/vadd/5ce7ffcc8c944e092109c7d1f0cf5703.png',
          'https://qncweb-back1.ktvsky.com/20210708/vadd/a63b38f301642aaecc7e38bed5e69473.png',
          // 'https://qncweb-back1.ktvsky.com/20210708/vadd/6e373f5cc8c9061d30340464582fd2df.png',
          'https://qncweb-back1.ktvsky.com/20210708/vadd/f4c463ff533d08dd853bb371beb26700.png',
        ],
        page_tp: fromType,
        statName: '已点歌曲-vip置顶区开通会员弹窗',
        packageLogo: true,
        event: this,
        propStyleVar: {
          fontColor: {
            normal: ['#4A4949', '#B64404', '#A4A4A4'],
            selected: ['#fff', '#EDD7B3', '#fff'],
          },
          packageBg: '#FFFFFF',
          packageBgSelected: 'linear-gradient(180deg,#000000, #543c13)',
          tipBg: '#018864',
          plusColor: '#FF0000',
          tagBg: '#F2483D',
          swiperBulletBg: '#907f60',
          swiperBulletActiveBg: '#090602',
          buttonHeight: '26.2vw',
          borderColor: {
            normal: '#FFEECC',
            selected: '#FFBC54',
          },
          logoBg: {
          normal: '#FFEECC',
            selected: '#FFEECC',
          },
        },
      });
    },
    openToping(statName, eventName, imgUrl, btnHeight, showGiveFriend, callback) {
      this.$sendLog({
        event_type: 'show',
        event_name: eventName,
      });
      this.$RaiseNewPayment({
        contentBg: imgUrl,
        swiperData: [
          'https://qncweb-back1.ktvsky.com/20210708/vadd/5ce7ffcc8c944e092109c7d1f0cf5703.png',
          'https://qncweb-back1.ktvsky.com/20210708/vadd/a63b38f301642aaecc7e38bed5e69473.png',
          // 'https://qncweb-back1.ktvsky.com/20210708/vadd/6e373f5cc8c9061d30340464582fd2df.png',
          'https://qncweb-back1.ktvsky.com/20210708/vadd/f4c463ff533d08dd853bb371beb26700.png',
        ],
        page_tp: statName,
        statName: eventName,
        isShowGiveFriend: showGiveFriend,
        giveFriendConfig: {
          color: '#ff3a3a',
          bg: 'https://qncweb-back1.ktvsky.com/20211202/vadd/77090a60ffb6f3f79957f1d814867378.png',
          point: 'https://qncweb-back1.ktvsky.com/20211202/vadd/12b3a7223e6a21a8ccdba69fb18d88c2.png',
        },
        event: this,
        propStyleVar: {
          fontColor: {
            normal: ['#4A4949', '#B64404', '#A4A4A4'],
            selected: ['#fff', '#EDD7B3', '#fff'],
          },
          packageBg: '#FFFFFF',
          packageBgSelected: 'linear-gradient(180deg,#000000, #543c13)',
          tipBg: '#3B2B0D',
          plusColor: '#B750FA',
          tagBg: '#F2483D',
          swiperBulletBg: '#907f60',
          swiperBulletActiveBg: '#090602',
          buttonHeight: btnHeight,
          borderColor: {
            normal: '#FFEECC',
            selected: '#FFBC54',
          },
          logoBg: {
            normal: '#FFEECC',
            selected: '#FFEECC',
          },
        },
        isbuyVipCallback: callback ? 'true' : 'false',
        buyVipCallback: () => {
          if (callback) {
            callback()
          }
        },
      });
    },
    openRedPacket(payload, imgUrl, statName, pay_url, discount_fee = 5) {
      const oldVipArr = {
        homeToast: {
          pay_enter: 'oldvip_diange2',
        },
        orderSong: {
          pay_enter: 'vip_expire_kaiping2',
        },
      };
      const newCurrentData = oldVipArr[payload];
      this.$sendLog({
        event_type: 'show',
        event_name: '新红包弹窗',
      });
      reportPay({
        page_tp: statName || newCurrentData.pay_enter,
        active_tp: 3001, // 用户行为：0：点击 ;1：停留
        source: 0,
      });
      const url = imgUrl || 'https://qncweb-back1.ktvsky.com/20210707/vadd/7ba18da315c03108a3f19254124bf228.png';
      this.$RaiseMessage.alert(url, '', {
        countDownEndTime: 180000,
        restStyle: {
          clickArea: {
            position: 'relative',
          },
        },
        callback: () => {
          this.$sendLog({
            event_type: 'click',
            event_name: '点击立即使用',
            event_data: {
              action: '新红包弹窗',
            },
          });
          reportPay({
            page_tp: statName || newCurrentData.pay_enter,
            active_tp: 3000, // 用户行为：0：点击 ;1：停留
            source: 0,
          });
          this.$sendLog({
            event_type: 'show',
            event_name: '新红包引导vip弹窗',
          });
          this.$RaiseNewPayment({
            contentBg: pay_url || 'https://qncweb-back1.ktvsky.com/20210708/vadd/04155a927822e7b5064d681db2ff7c64.png',
            swiperData: [
              'https://qncweb-back1.ktvsky.com/20210707/vadd/df732281ca89a12bc6af04cfedb793b2.png',
              'https://qncweb-back1.ktvsky.com/20210708/vadd/89e2e8a3fb8bd064d009544cbedebf68.png',
              // 'https://qncweb-back1.ktvsky.com/20210707/vadd/02a4d73a1b8b8f960dbe7f16bf3d761c.png',
              'https://qncweb-back1.ktvsky.com/20210707/vadd/70a14e74cdcc3ae80a0979128e883970.png',
            ],
            page_tp: statName || newCurrentData.pay_enter,
            statName: '新红包引导vip弹窗',
            event: this,
            price: [690, 1690, 3690],
            // 兼容其它场景弹窗
            memberIdArr: [69, 70, 64],
            memberIdArr1: [69, 70, 64],
            isDiscount: discount_fee === 5, // 立减5元
            isDiscount1: discount_fee === 3, // 立减3元
            packagesContent: {
              tagContent: ['', '', ''],
            },
            // 兼容其它场景弹窗 end
            propStyleVar: {
              fontColor: {
                normal: ['#4A4949', '#FA810D', '#7B7676'],
                selected: ['#FFFFFF', '#EDD7B3', '#FFFFFF'],
              },
              packageBg: '#FFFFFF',
              packageBgSelected: 'url(https://qncweb-back1.ktvsky.com/20210708/vadd/c040da6a59bf5e92951436c266409048.png)',
              tipBg: '#3B2B0D',
              plusColor: '#953DFE',
              tagBg: '#F2483D',
              swiperBulletBg: '#8E7D5E',
              swiperBulletActiveBg: '#090602',
              buttonHeight: '25vw',
            },
          });
        },
        closeImg: require('@/views/vip/static/plus/vip_close.png'),
      });
    },
    openRedPacket2() {
      this.$sendLog({
        event_type: 'show',
        event_name: '新红包弹窗',
      });
      this.$RaiseNewPayment({
        ...secondHomeToastRole2,
        page_tp: 'oldvip_diange2',
        contentBg: 'https://qncweb.ktvsky.com/20250718/vadd/e8cbea589bf1b9587c377e966136f458.png',
        event: this,
        showAgreementText: true,
        giveFriendConfig: {
          ...secondHomeToastRole2.giveFriendConfig,
          bg: 'https://qncweb.ktvsky.com/20250718/vadd/957cf48a37660997e3e04f7a8082e962.png',
          leftSelected: '4vw',
        },
        propStyleVar: {
          ...secondHomeToastRole2.propStyleVar,
          maskColor: '#00000099',
          monthColorSpan: '#F00000',
          packageBgSelected: '#FBECD2',
          buttonHeight: '16vw',
          borderColor: {
            normal: '#E6E6E6',
            selected: '#FA3D54',
          }
        }
      });
    },
    commonLog(currentData, action = 'show') {
      this.$sendLog({
        event_type: action,
        event_name: `${currentData.name}召回弹窗`,
        event_data: {
          page: currentData.page,
        },
      });
    },
    handleClickTestOldVip(payload) {
      this.$sendLog({
        event_type: 'click',
        event_name: mineEvents[payload].name,
        event_data: {
          name: '过期',
          page: '我的页',
        },
      });
      if (payload === 'openvip') {
        this.$router.push('/thunder/openvip?fromType=becomeVip');
      } else {
        utils.util.buyVipPlus({
          $this: this,
          pay_enter: mineEvents[payload].pay_enter,
        });
      }
    },
    showNewUser(page_tp = 'kaiping_moresong') {
      this.$sendLog({
        event_type: 'show',
        event_name: '开屏弹窗新用户第一个弹窗',
        event_data: {
          action: '展示',
        },
      });
      let config = {}

      if (this.role === 'role5') {
        config = {
          ...secondHomeToastRole2,
          contentBg: 'https://qncweb.ktvsky.com/20250729/vadd/005af0e243d9bf93a4e00b214c69a169.png',
          newCloseImg: 'https://qncweb.ktvsky.com/20250402/vadd/b41aa6618d66870e7abeb9e5dba6a9c3.png',
          closeClassName: 'top-right-close-new',
          topAgreement: true,
          packagesContent: {
            ...secondHomeToastRole2.packagesContent,
            countdownTime: 3,
          },
          page_tp,
          propStyleVar: {
            ...secondHomeToastRole2.propStyleVar,
            maskColor: '#00000099',
            buttonHeight: '25vw',
          }
        }
      }
      if (this.role === 'role2') {
        config = {
          newCloseImg: 'https://qncweb.ktvsky.com/20250415/vadd/8dfdb9e557814ac9c702e3c318be3bcb.png',
          closeClassName: 'top-right-close-new',
          isShowCountDownNoFinish: true,
          isMonthDiscount: true,
          tagContentNew: ['', '立减5元', ''],
          selectIndex: 1,
          isDiscount: true,
          propStyleVar: {
            ...firstHomeToast.propStyleVar,
            maskColor: '#000000CC',
          }
        }
      }
      this.$RaiseNewPayment({
        ...firstHomeToast,
        ...config,
        event: this,
        cancelcallback: () => {
          utils.alert.showExperienceDialog(this)
        },
        cancelCloseCallBack: () => {
          utils.alert.showExperienceDialog(this)
        },
        clickCloseCallback: () => {
          utils.alert.showExperienceDialog(this)
        },
      });
    },
    openstartAnimationVip(formtype, event) {
      const obj = {
        contentBg: 'https://qncweb-back1.ktvsky.com/20211027/vadd/b4fb073e8ae75282f59ea37c7dcbce5a.png',
        contentImg: 'https://qncweb-back1.ktvsky.com/20220614/vadd/e993f9966bae7e7a6a21ec5bbb79df1b.png',
        mainImgHeight: '92vw',
        payVipButtonHeight: '35vw',
        isToping: false,
      }
      if (window.location.href.includes('touch_order_vip')) {
        obj.contentBg = 'https://qncweb-back1.ktvsky.com/20211105/vadd/3d069efd9235d07881fc2a6191211554.png';
        obj.contentImg = 'https://qncweb-back1.ktvsky.com/20220614/vadd/c6383d4d13ca8499dc8ca96dbfb12c54.png';
        obj.mainImgHeight = '108vw';
        obj.payVipButtonHeight = '19vw';
        obj.isToping = true;
      }
      this.$RaiseAnimationPayment({
        contentBg: obj.contentBg,
        contentImg: obj.contentImg,
        event,
        memberId: 81,
        pay_fee: 990,
        isToping: obj.isToping,
        page_tp: formtype,
        propStyleVar: {
          textColor: '#FDDD98',
          mainImgHeight: obj.mainImgHeight,
          payVipButtonHeight: obj.payVipButtonHeight,
        },
      });
    },
    openMembershipVip(formtype, statname, event) {
      const $this = event || this;
      const bg = statname == '首页通告栏' ? 'https://qncweb-back1.ktvsky.com/20210715/vadd/4939795d597591974988b407eb027fef.png' : 'https://qncweb-back1.ktvsky.com/20210715/vadd/eafbbc9815e353ded1778c2bfd14b665.png';
      this.$RaiseFocusMessage({
        swiperData: [
          'https://qncweb-back1.ktvsky.com/20210713/vadd/5c2947cb6d6f62a4fe77ca9a22f870e5.png',
          'https://qncweb-back1.ktvsky.com/20210713/vadd/84a466da83a44458e0ab227e1edf311a.png',
          'https://qncweb-back1.ktvsky.com/20210713/vadd/9b02402f5c4de66c897dd7d995358cba.png',
          'https://qncweb-back1.ktvsky.com/20210713/vadd/126e2313a8e79783a6bdcac615e6faf6.png',
        ],
        bulletName: 'bigScreen7',
        swiperStyle: { backgroundImage: `url(${bg})`, paddingTop: '59vw', height: '108vw' },
        btnStyle: 'margin-top: 4vw',
        swiperBoxStyle: { width: '96%' },
        page_tp: formtype,
        buyVipPlus: () => {
          this.$sendLog({ event_type: 'click', event_name: '立即升级', event_data: { page_name: statname } });
          utils.util.buyVipPlus({
            memberId: 108,
            pay_fee: 590,
            $this,
            pay_enter: formtype,
            callback: () => {
              $this.$store.dispatch('getIsVip');
              $this.$RaiseMessage.close(true);
              $this.$store.commit('SAVE_HOME_TOAST', false);
              $this.$store.commit('SET_VIP_PACKAGES_TOAST');
              this.$RaiseMessage.alert('https://qncweb-back1.ktvsky.com/20210715/vadd/3ae21238164f4962f699ab4a45d12ae5.png', '', {
                callback: () => {
                  window.location.href = 'https://tq.jfshou.cn/seller/classify?agentId=558&inviteBuyerId=-1&shareBuyerId=0&wxCode=365TQ';
                },
                closeImg: require('@/views/vip/static/plus/vip_close.png'),
              });
            },
          });
        },
      });
    },
    openDJhot(formtype, item) {
      const songItem = item || this.item
      if (this.$route.query.paySuffix?.includes('sort_bottom')) {
        formtype = `djhot_pay_${this.$route.query.paySuffix}`
      }
      const basePageTp = formtype || 'djhot_pay'
      const songPayload = {
        event: this,
        songItem: {
          ...songItem,
          type: 'djhot', // VIP伴奏榜部分数据缺失歌曲类型
        },
      }
      // role4：与 role5 歌手详情页-高品质歌曲-从未付费弹窗一致，并走公共 AB（配置合入、page_tp 加 A/B 前缀）
      if (this.role === 'role4') {
        const djhotRole4PayToast = {
          ...cloneDeep(SearchResultHQsongRole4),
          contentBg: 'https://qncweb.ktvsky.com/20251119/vadd/00567646b3490ee3fb1f5320a7cc6176.png',
          tagContentVipNew: ['', '限时立减', ''],
          packagesContent: {
            ...(SearchResultHQsongRole4.packagesContent || {}),
            countdownSuffixText: '后结束',
          },
          propStyleVar: {
            ...SearchResultHQsongRole4.propStyleVar,
            buttonHeight: '24vw',
            handTop: '70vw',
          },
          statName: djhotToast.statName,
        }
        return raisePaymentWithAb(this.$RaiseNewPayment, {
          experimentId: `${basePageTp}_${this.role}`,
          uid: this.unionid || this.openid,
          pageTp: basePageTp,
          ...djhotRole4PayToast,
          ...songPayload,
        })
      }
      this.$RaiseNewPayment({
        ...djhotToast,
        page_tp: basePageTp,
        ...songPayload,
      });
    },
    openVIPFirst(formtype = 'newsong_vip', statName, selectIndex, role, isSearch, closeCallback) {
      // 默认配置
      const defaultVIPFirst = {
        contentBg: 'https://qncweb-back1.ktvsky.com/20230726/other/b01349da89147eeb2654f3f50180fad6.png',
        propStyleVar: {
          fontColor: {
            normal: ['#4A4949', '#FA810D', '#7B7676'],
            selected: ['#FFFFFF', '#EDD7B3', '#FFFFFF'],
          },
          packageBg: '#FFFFFF',
          packageBgSelected: 'linear-gradient(180deg,#000000, #543c13)',
          tipBg: '#3B2B0D',
          plusColor: '#B750FA',
          tagBg: '#F2483D',
          swiperBulletBg: '#907f60',
          swiperBulletActiveBg: '#090602',
          buttonHeight: '20.5vw',
          borderColor: {
            normal: '#FFEECC',
            selected: '#FFBC54',
          },
          logoBg: {
            normal: '#FFEECC',
            selected: '#FFEECC',
          },
        },
      };

      // 根据角色和场景选择配置
      let vipFirst = defaultVIPFirst;
      if (formtype === 'home_tops_qx' && ['role2', 'role5'].includes(role)) {
        return this.$RaiseNewPayment({
          ...vipFirstTopRole2,
          event: this,
          page_tp: formtype,
          statName,
          songItem: this.item,
          iscloseCallback: true,
          closeCallback: () => {
            closeCallback();
          },
        });
      }

      if (role === 'role4') {
        vipFirst = vipFirstRole4;
        if (isSearch) {
          vipFirst = {
            ...vipFirst,
            contentBg: 'https://qncweb.ktvsky.com/20250919/vadd/6b966d4be2f41150b346e12f15408366.png',
            isShowBtnCountDown: false,
            isShowTextCountDown: true,
            countdownPrefixText: '❗您的专属折扣 即将消失',
            topAgreement: true,
            showTopAgreement: false,
            isMonthDiscount: true,
            discountIndex: 1,
            discountDayFee: '0.02',
            isSpecialPackages: 1,
            price: [990, 1690, 2190],
            memberIdArr1: [78, 70, 50],
            isDiscount1: true, // 立减3元
            packagesContent: {
                showTag: true,
                month: ['24小时', '1个月', '3个月'],
                current: ['¥<span>0.41</span>/小时', '¥<span>0.02</span>/小时', '¥<span>0.01</span>/小时'],
                origin: ['¥9.9', '¥16.9<i>¥19.9</i>', '¥21.9<i>¥29.9</i>'],
                tagContent: ['', '立省3元', ''],
            },
            propStyleVar: {
              ...vipFirst.propStyleVar,
              packageBgSelected: '#FFF3F3',
              topAgreementTop: '-36vw',
              buttonHeight: '19vw',
              borderColor: {
                normal: 'rgba(0, 0, 0, 0.05)',
                selected: '#FF5A70',
              },
              borderWidth: {
                selected: '0.8vw',
              },
            },
          };
        }
      } else if (isSearch) {
        vipFirst = ['role2'].includes(this.role) ? searchFirstToastNew : searchFirstToast;
        if (this.role === 'role2') {
          vipFirst = {
            ...vipFirst,
            contentBg: 'https://qncweb.ktvsky.com/20250911/vadd/4bb88f919ec2a3b3dc5d2e6c000a5826.png',
            countdownPrefixText: '❗抢鲜优惠即将消失',
            isMonthDiscount: true,
            discountIndex: 1,
            discountDayFee: '0.02',
            isSpecialPackages: 1,
            price: [990, 1690, 2190],
            memberIdArr1: [78, 70, 50],
            isDiscount1: true, // 立减3元
            packagesContent: {
                showTag: true,
                month: ['24小时', '1个月', '3个月'],
                current: ['¥<span>0.41</span>/小时', '¥<span>0.02</span>/小时', '¥<span>0.01</span>/小时'],
                origin: ['¥9.9', '¥16.9<i>¥19.9</i>', '¥21.9<i>¥29.9</i>'],
                tagContent: ['', '立省3元', ''],
            },
            propStyleVar: {
              ...vipFirst.propStyleVar,
              tagTop: '-2vw',
              tagPadding: '0 1.467vw',
              tagRadiusNew: '20px 20px 20px 0',
            }
          }
        }
      }

      // role5 搜索场景特殊配置
      let configRole5 = null;
      if (this.role === 'role5' && isSearch) {
        configRole5 = vipFirstSearchRole5
        if (this.is_leike_device) {
          configRole5 = {
            ...configRole5,
            isDiscount: true,
            isMonthDiscount: true
          };
        }
      }

      // 合并配置并渲染弹窗
      const raisePayload = {
        ...vipFirst,
        selectIndex,
        showAgreement: true,
        page_tp: formtype,
        statName,
        event: this,
        showTip: true,
        songItem: this.item,
        iscloseCallback: true,
        ...(configRole5 || {}),
        closeCallback: () => {
          closeCallback();
        },
      }
      // 搜索页 role2 抢鲜唱：接入 AB（公共封装），接口返回配置合入弹窗配置；page_tp 前加 A/B
      if (isSearch && this.role === 'role2') {
        return raisePaymentWithAb(this.$RaiseNewPayment, {
          experimentId: `${formtype}_${this.role}`,
          uid: this.unionid || this.openid,
          pageTp: formtype,
          ...raisePayload,
        })
      }
      this.$RaiseNewPayment(raisePayload);
    },
    openMaibabidian(formtype, item) {
      const songItem = item || this.item
      this.$RaiseNewPayment({
        contentBg: 'https://qncweb-back1.ktvsky.com/20221116/vadd/c22049c685d598b497472eb3103b49c4.png',
        isShowFootbar: true,
        showOriginal: true,
        page_tp: formtype || 'maibasong',
        statName: '麦霸版歌曲收入—8.12',
        event: this,
        isShowGiveFriend: true,
        giveFriendConfig: {
          color: '#ff3a3a',
          bg: 'https://qncweb-back1.ktvsky.com/20211202/vadd/77090a60ffb6f3f79957f1d814867378.png',
          point: 'https://qncweb-back1.ktvsky.com/20211202/vadd/12b3a7223e6a21a8ccdba69fb18d88c2.png',
        },
        songItem: {
          ...songItem,
          type: 'maibabidian',
        },
        propStyleVar: {
          fontColor: {
            normal: ['#4A4949', '#FA810D', '#7B7676'],
            selected: ['#FFFFFF', '#EDD7B3', '#FFFFFF'],
          },
          packageBg: '#FFFFFF',
          packageBgSelected: 'linear-gradient(180deg,#000000, #543c13)',
          tipBg: '#3B2B0D',
          plusColor: '#B750FA',
          tagBg: '#F2483D',
          swiperBulletBg: '#907f60',
          swiperBulletActiveBg: '#090602',
          buttonHeight: '24vw',
          borderColor: {
            normal: '#FFEECC',
            selected: '#FFBC54',
          },
          logoBg: {
            normal: '#FFEECC',
            selected: '#FFEECC',
          },
        },
      });
    },
    openYinyi(formtype, item, statName, scene) {
      const songItem = item || this.item
      this.$RaiseNewPayment({
        contentBg: 'https://qncweb-back1.ktvsky.com/20220506/other/8cb01b9d4302debd8dcf26cd9cce4412.png',
        isShowFootbar: true,
        showOriginal: true,
        page_tp: formtype || 'yinyi',
        statName,
        scene,
        event: this,
        songItem: {
          ...songItem,
          type: 'yinyi',
        },
        propStyleVar: {
          fontColor: {
            normal: ['#666666', '#380AB4', '#9B9FA7'],
            selected: ['#29229D', '#380AB4', '#A398DB'],
          },
          packageBg: '#FFFFFF',
          packageBgSelected: '#F0ECFE',
          tipBg: '#692AE8',
          plusColor: '#692AE8',
          tagBg: '#F2483D',
          swiperBulletBg: '#907f60',
          swiperBulletActiveBg: '#090602',
          buttonHeight: '26vw',
          borderColor: {
            normal: '#D7D7D7',
            selected: '#6530ED',
          },
          logoBg: {
            normal: '#FFEECC',
            selected: '#FFEECC',
          },
          customerBorder: true,
          customerLeftBg: true,
          customerRightBg: true,
        },
      });
    },
    // role1用户开屏弹窗检查发照片权限
    async checkPhotoPrivilegeForRole1() {
      try {
        const photoParams = {
          openid: this.openid,
          unionid: this.unionid,
        };
        const res = await chttp.get(apis.photo_pagv3, { params: photoParams });
        const hasPrivilege = res.data.privilege;
        this.photoData = res.data;

        // 如果没有权限，才显示发照片弹窗
        if (!hasPrivilege) {
          this.showNewToastNew();
        }
      } catch (error) {
        console.error('获取照片权限失败', error);
      }
    },
    showNewToastNew() {
      this.$sendLog({
        event_type: 'show',
        event_name: '开屏弹窗-发照片弹窗-展示',
        event_data: {
          fromType: `photoT_homeToast_${this.photoPath.entrance}`,
          name: this.photoPath?.label || '',
        }
      })
      this.$RaiseMessage.alert('https://qncweb.ktvsky.com/20250715/vadd/8acb27e266a877f451e83adc84c63f76.png', '', {
        callback: () => {
          this.$sendLog({
            event_type: 'click',
            event_name: '开屏弹窗-发照片弹窗点击是',
            event_data: {
              data: '是',
            },
          });
          this.$RaiseMessage.close()

          // 调起支付，使用photoData中的参数
          if (this.photoData && this.photoData.package && this.photoData.package.all && this.photoData.package.all.novip) {
            this.$store.dispatch('wxpay', {
              params: {
                unionid: this.unionid,
                openid: this.openid,
                pkg_id: this.photoData.package.all.novip.pkg_id,
                entrance: `photoT_homeToast_${this.photoPath.entrance}`,
              },
              wxUrl: apis.privilegeWxpay,
              elseData: {
                callback: () => {
                  // 支付成功后跳转到娱乐页面
                  if (this.$store.state.bless_path.includes('blessv1')) {
                    this.$router.push('/thunder/interact');
                  } else {
                    this.$router.push(this.$store.state.photo_interact_path_new);
                  }
                }
              }
            });
          } else {
            console.error('无法获取照片套餐信息');
          }
        },
        restStyle: {
          img: {
            width: '100vw',
            position: 'fixed',
            bottom: '0',
            left: '0'
          },
          wrapper: {
            alignItems: 'flex-end',
          },
          preciseCountdown: {
            bottom: '88vw',
            width: '100%',
          }
        },
        onlyBtnClose: true,
        showBreathBtns: true,
        showClose: false,
        showScrollMessages: true,
        preciseBtnConfig: {
          cancelBtnImg: 'https://qncweb.ktvsky.com/20250603/vadd/adfd8cae610de5726b65e89e262e64ee.png',
          confirmBtnImg: 'https://qncweb.ktvsky.com/20250603/vadd/0932b9e2eb3ef8687d46d11d4528286c.png',
          confirmBtnBreath: false, // 关闭呼吸动画
          bottom: '9vw',
        },
        closeCallback: () => {
          this.$sendLog({
            event_type: 'click',
            event_name: '开屏弹窗-发照片弹窗点击否',
            event_data: {
              data: '否',
            },
          });
        },
      });
    },
  },
  mounted() {
    if (this.$route && this.$route.query.isNewUser) { // 因为后端暂时清不掉，只能前端去切换新用户与否
      this.$store.commit('SET_VIP_ENDTIME', '');
    }
  },
};
